import KumovegaError from "./KumovegaError";

export default class ServerError extends KumovegaError {}
